// Angular dependencies
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PageMainRouterModule } from './page-main.router';
import { CoreModule } from '../core.module';

// Import vendor modules
import { NgxPopperModule } from 'ngx-popper';

// Page main component
import { PageMainComponent } from './page-main.component';

// Componets of page
import { AccountLevelComponent } from './account-level.component';
import { CreepComponent } from './creep.component';
import { PowerResourceNeededComponent } from './power-resource-needed.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CoreModule,
    // Vendors
    NgxPopperModule.forRoot({
       disableDefaultStyling: true,
       placement: 'bottom'
    }),
    // Page route
    PageMainRouterModule
  ],
  declarations: [
    PageMainComponent,
    // Componets of this page
    AccountLevelComponent,
    CreepComponent,
    PowerResourceNeededComponent
  ],
  providers: [

  ]
})
export class PageMainModule {
}



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/page-main.module/page-main.module.ts